import './css/Mensajes.css';
import { useEffect, useRef, useState } from "react";
import axios from 'axios';
import { show_alerta } from '../../funciones.js';
import CONFIG from '../../config';
import EmojiTextarea from './EmojiTextarea';
import Espera from '../Espera.js';
import EsperaFull from '../EsperaFull.js';

const URL_USUARIOS = `${CONFIG.API_URL}/operarTablaUsuario.php`;

function MensajesCrudForm({ enviarFormData, respuesta_a, para_r, asunto_r, llamoNuevo, cerrarModal, textareaRef, preload }) {
    const [de, setDe] = useState("");
    const [para, setPara] = useState(para_r);
    const [asunto, setAsunto] = useState(asunto_r);
    const [mensaje, setMensaje] = useState("");
    const [files, setFiles] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [sugerencias, setSugerencias] = useState([]);
    const [habilitaEnvio, setHabilitaEnvio] = useState(false);
    const loggeduserRolId = localStorage.getItem('loggeduserRolId');
    //Para grabacion
    const [grabando, setGrabando] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioBlob, setAudioBlob] = useState(null);
    const [audioURL, setAudioURL] = useState(null);
    const [tiempoGrabacion, setTiempoGrabacion] = useState(0);
    const timerRef = useRef(null);
    const streamRef = useRef(null);

    useEffect(() => {
        setDe(JSON.parse(localStorage.getItem('loggeddatosuser')).usuario);
        obtenerUsuariosPermitidos(loggeduserRolId);
    }, []);
    
    const obtenerUsuariosPermitidos = (rol_origen) =>{
        axios.get(`${URL_USUARIOS}?rol_origen=${rol_origen}`)
            .then(res => { setUsuarios(res.data); console.log('usuariosPermitidos:',res.data);})
            .catch(err => { console.error("Error al obtener usuarios:", err); });
    }
    
    useEffect(() => {
        const termino = para.split(',').slice(-1)[0].trim();

        if (termino.length >= 2) {

            const texto = normalizarTexto(termino);

            const filteredUsers = usuarios.filter(usuario =>
                normalizarTexto(
                    `${usuario.nombre} ${usuario.apellido} ${usuario.usuario} ${usuario.roles || ''}`
                ).includes(texto)
            );

            setSugerencias(filteredUsers);
        } else {
            setSugerencias([]);
        }
    }, [para, usuarios]);

    const seleccionarUsuario = (usuario) => {
        const nuevosPara = para.split(',').slice(0, -1).concat(`${usuario.usuario} <<${usuario.nombre} ${usuario.apellido}>>,`).join(', ');
        setPara(nuevosPara);
        setHabilitaEnvio(true);
        setSugerencias([]);
    };

    const handleSubmint=(e)=> {
        e.preventDefault();
        if (!para || !asunto) {
            show_alerta('Faltan datos', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('respuesta_a', respuesta_a);
        formData.append('de', de);
        formData.append('para', para);
        formData.append('asunto', asunto);
        formData.append('mensaje', mensaje);

        files.forEach((file, index) => {
            formData.append(`file${index}`, file);
        });
        if (audioBlob) {
            formData.append('audio', audioBlob, 'audio.webm');
        }
        enviarFormData(formData);
        handleReset();
    }

    const handleReset = () => {
        setPara("");
        setAsunto("");
        setMensaje("");
        setFiles([]);
        setAudioBlob(null);
        setAudioURL(null);
    };

    const handleCerrar = () => {
        if (llamoNuevo) {
            cerrarModal();
        } else {
            cerrarModal(false);
        }
    };

    const normalizarTexto = (texto) => {
        return (texto || "")
            .toLowerCase()
            .normalize("NFD") // separa letras de acentos
            .replace(/[\u0300-\u036f]/g, ""); // elimina acentos
    };
    
    //Funciones para  grabacion de audio
    const iniciarGrabacion = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            streamRef.current = stream; // 👈 GUARDAR STREAM

            const recorder = new MediaRecorder(stream);

            let chunks = [];

            recorder.ondataavailable = (e) => {
                chunks.push(e.data);
            };

            recorder.onstop = () => {
                const blob = new Blob(chunks, { type: 'audio/webm' });
                setAudioBlob(blob);
                setAudioURL(URL.createObjectURL(blob));
            };

            recorder.start();
            setMediaRecorder(recorder);
            setGrabando(true);

            // 🔥 INICIAR CONTADOR
            setTiempoGrabacion(0);
            timerRef.current = setInterval(() => {
                setTiempoGrabacion(prev => prev + 1);
            }, 1000);

        } catch (err) {
            console.error(err);
            show_alerta("No se pudo acceder al micrófono", "error");
        }
    };

    const detenerGrabacion = () => {
        if (mediaRecorder) {
            mediaRecorder.stop();
            setGrabando(false);
            
            // 🔥 DETENER MICRÓFONO REAL
            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop());
                streamRef.current = null;
            }
            // DETENER CONTADOR
            clearInterval(timerRef.current);
        }
    };

    const formatearTiempo = (segundos) => {
        const min = Math.floor(segundos / 60);
        const sec = segundos % 60;
        return `${min}:${sec.toString().padStart(2, '0')}`;
    };

    return (
    <div className="me-2">
    {!preload?  
        <form onSubmit={handleSubmint} id='form'>
            <input type="hidden" name="respuesta_a" value={respuesta_a} />
            {llamoNuevo? 
            <>
                {/*si es mensaje directo nuevo */}
                {para_r==''?
                <>
                {/* Campo de texto para ingresar destinatario solo si es mensaje nuevo sin destinatario predefinido */}
                    <div className='input-group input-group-sm mb-3'>
                        <span className='input-group-text' id='inputGroup-sizing-sm'>Para</span>
                        <input
                        type="text"
                        className="form-control bg-light"
                        name="para"
                        placeholder="Destinatario"
                        autoComplete="off"
                        value={para}
                        onChange={(e) => setPara(e.target.value)}
                        aria-label="Sizing example input" 
                        aria-describedby="inputGroup-sizing-sm"
                        />
                    </div>
                </>
                :
                <>
                    <input
                        type="hidden"
                        className="form-control bg-light"
                        name="para"
                        placeholder="Destinatario"
                        autoComplete="off"
                        value={para}
                        onChange={(e) => setPara(e.target.value)}
                        aria-label="Sizing example input" 
                        aria-describedby="inputGroup-sizing-sm"
                    />
                </>
                }
                
                {sugerencias.length > 0 && (
                    <ul className="lista-sugerencias">
                        {sugerencias.map(usuario => (
                            <li key={usuario.usuario} onClick={() => seleccionarUsuario(usuario)}>
                                {usuario.nombre} {usuario.apellido} 
                                <small style={{color: '#666'}}> ({usuario.roles})</small>
                            </li>
                        ))}
                    </ul>
                )}
                {para}
                <div className='input-group m-1'>
                    <span className='input-group-text small'>Asunto</span>
                    <input
                        type="text"
                        className="form-control bg-light"
                        name="asunto"
                        onChange={(e) => setAsunto(e.target.value)}
                        value={asunto}
                    />
                </div>
            </>
            : 
            <>
            {/*Si es respuesta a mensaje, los campos para y asunto vienen ocultos pero con valor para enviar */}
                <input type="hidden" name="para" value={para} />
                <input type="hidden" name="asunto" value={asunto} />
            </>
            }
            {/* NUEVO TEXTAREA CON EMOJIS */}
            {!audioURL && !grabando &&
            <EmojiTextarea
                value={mensaje}
                onChange={setMensaje}
                rows={(llamoNuevo && para_r=='')?8:respuesta_a==0?1:8} // si es mensaje nuevo sin destinatario predefinido, textarea grande. Si es respuesta, una linea solo si no es respuesta a mensaje (respuesta_a==0), sino grande
                placeholder="Mensaje aquí"
                name="mensaje"
            />
            }
            <div className="d-flex align-items-center flex-wrap gap-2"> 
            {/*si NO es grupal no muestro boton enviar audio */}
                {!(llamoNuevo && para_r=='')&& (
                    <>
                    {/* BOTON GRABAR */}
                    {!audioURL?
                        !grabando ? (
                            <button
                                type="button"
                                className="btn btn-warning me-1"
                                onClick={iniciarGrabacion}
                            >
                                <i className="fa-solid fa-microphone"></i>
                            </button>
                        ) : 
                        <>
                            <button
                                type="button"
                                className="btn btn-dark me-1"
                                onClick={detenerGrabacion}
                            >
                                <i className="fa-solid fa-stop"></i>
                            </button>
                            <div className="d-flex align-items-center gap-2 text-danger fw-bold">
                                <span>●</span>
                                <span>{formatearTiempo(tiempoGrabacion)}</span>
                            </div> 
                        </>
                    :
                    <span className='p-2'>
                        {/* PREVIEW */}
                        {audioURL && (
                            <div className="flex-grow-1 d-flex justify-content-center">
                                <div className="audio-preview-box">
                                    <audio controls src={audioURL}></audio>
                                </div>
                            </div>
                        )}
                    </span>
                    }
                    </>
                )}
            {/*si voy a grabar un audio nopuedo adjuntar otro archivo el adjunto sera el audio */}
                {!audioURL && !grabando &&
                    <label className="btn btn-secondary px-3 my-1">
                        <i className="fa-solid fa-paperclip"></i>{files.length > 0 ? `Archivos: ${files.length}` : ''}
                        <input
                            type="file"
                            name="file"
                            multiple
                            onChange={(e) => {
                                const archivos = [...e.target.files];
                                setFiles(archivos);
                                console.log("Archivos:", archivos.length);
                            }}
                            hidden
                        />
                    </label>
                }
            {/* si no esta grabando muestro el boton enviar */}
                {!grabando &&
                    <button 
                    className="btn btn-success m-1 px-5" 
                    type="submit" 
                    disabled={(!habilitaEnvio && !respuesta_a && !para_r)}
                    >
                        <i className="fa-solid fa-paper-plane"></i>
                    </button> 
                }
                {/*si es grupal no muestro boton limpiar porque no tiene sentido limpiar el destinatario */}
                {(llamoNuevo && para_r=='')&& (
                    <input
                        className="btn btn-warning m-1"
                        type="reset"
                        value="Limpiar"
                        onClick={handleReset}
                    />
                )}
                <button
                    type="button"
                    id="btnCerrar"
                    className="btn btn-secondary ms-4"
                    onClick={handleCerrar}
                >
                    X
                </button>
            </div>   
        </form>
    :
        <EsperaFull visible={preload} />
    }
    </div>
    )
}

export default MensajesCrudForm;
